import React from 'react';
import styled from 'styled-components';

export const categoryTreeUrl =
  'https://cms.grofer.io/content-ops/category-tree';

export const ACTION = {
  VIEW: 'View',
  REVIEW: 'Review',
};

export const ENTITY_TYPE = {
  CATEGORY: 'category',
  PRODUCT: 'product',
};

export const ConfigTabs = [
  {
    key: ENTITY_TYPE.CATEGORY,
    title: 'Category Level',
  },
  {
    key: ENTITY_TYPE.PRODUCT,
    title: 'Product Level',
  },
];

export const LeafTag = () => {
  return (
    <div className='tw-px-4 tw-py-2 tw-rounded-full tw-bg-yellow-700 tw-text-white'>
      Leaf
    </div>
  );
};

export const PrimaryTag = () => {
  return (
    <div className='tw-px-4 tw-py-2 tw-rounded-full tw-bg-blue-700 tw-text-white'>
      Primary
    </div>
  );
};

export const RootTag = () => {
  return (
    <div className='tw-px-4 tw-py-2 tw-rounded-full tw-bg-green-700 tw-text-white'>
      Root
    </div>
  );
};

export const AttributeTitle = {
  tat: 'Complaint Resolution Window (TAT)',
  return_service_promise_header: 'Return Policy Header',
  in_app_support_enabled: 'In-App Easy-Returns Enabled',
  in_app_return_enabled: 'In-App Return Enabled',
  in_app_exchange_enabled: 'In-App Exchange Enabled',
};

export const SLUGS = {
  TAT: 'tat',
  RETURN_SERVICE_PROMISE_HEADER: 'return_service_promise_header',
  RETURN_POLICY_IMAGE: 'return_policy_image',
  IN_APP_SUPPORT_ENABLED: 'in_app_support_enabled',
  IN_APP_RETURN_ENABLED: 'in_app_return_enabled',
  IN_APP_EXCHANGE_ENABLED: 'in_app_exchange_enabled',
};

export const Divider = () => {
  return (
    <div className='tw-w-full tw-border-solid tw-border-[0.1rem] tw-border-bottom-0 tw-border-x-0 tw-border-grey-200 tw-rounded-lg' />
  );
};

export const tabStyles = `
                  hr {
                    background-color: #318616 !important;
                    height: 4px;
                    border-radius: 4px 4px 0px 0px !important;
                    margin:0
                  }
                  h2 {
                    border: none !important;
                  }
                `;

export const TabsSectionWrapper = styled.div`
  > section {
    min-height: 0 !important;
    margin-top: 5px;
  }
`;

export const MIN_TAT = 0;
export const MAX_TAT = 15;

export const fetchTasksEndpoint = 'admin/category/tasks';
export const fetchCategoryListEndPoint = 'admin/category/list';

export const fetchChangeLogEndpoint = (taskId) =>
  `admin/category/task/changelog?task_id=${taskId}`;

export const getEntityDetailsEndpoint = (entityType, entityID) => {
  if (entityType === ENTITY_TYPE.CATEGORY)
    return `admin/category/attributes?category_id=${entityID}`;
  else if (entityType === ENTITY_TYPE.PRODUCT) {
    return `admin/product/attributes?product_id=${entityID}`;
  }
};

export const getEntityPreviewEndpoint = (entityType) => {
  if (entityType === ENTITY_TYPE.CATEGORY) return 'admin/category/attributes';
  else if (entityType === ENTITY_TYPE.PRODUCT) {
    return 'admin/product/bulk_update';
  }
};
